import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';

interface MaintenanceViewProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  retryLabel?: string;
  className?: string;
  /** Optional image URL (e.g. /maintenance.svg). Defaults to built-in illustration. */
  imageSrc?: string;
}

const defaultTitle = "We're doing some maintenance";
const defaultMessage =
  "Something went wrong on our end, or we're temporarily unavailable. Please try again in a few moments. If the problem persists, contact support.";

const DEFAULT_IMAGE = '/maintenance.svg';

export function MaintenanceView({
  title = defaultTitle,
  message = defaultMessage,
  onRetry,
  retryLabel = 'Try again',
  className = '',
  imageSrc = DEFAULT_IMAGE,
}: MaintenanceViewProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center rounded-lg border border-amber-200 bg-amber-50/80 p-8 text-center dark:border-amber-800 dark:bg-amber-950/30 ${className}`}
      role="status"
      aria-live="polite"
    >
      <img
        src={imageSrc}
        alt=""
        className="mb-6 h-36 w-auto max-w-[200px] object-contain"
      />
      <h2 className="text-lg font-semibold text-foreground">{title}</h2>
      <p className="mt-2 max-w-md text-sm text-muted-foreground">{message}</p>
      {onRetry && (
        <Button
          variant="outline"
          size="sm"
          onClick={onRetry}
          className="mt-6 gap-2 border-amber-300 bg-white hover:bg-amber-50 dark:border-amber-700 dark:bg-amber-950/50 dark:hover:bg-amber-900/40"
        >
          <RefreshCw className="h-4 w-4" />
          {retryLabel}
        </Button>
      )}
    </div>
  );
}
